/**
 * Add a class to <p> wrapping block-level elements to specify the embed block
 */
export const addEmbedClass = () => {
  // Embed tags to target
  const embeds = ['iframe', 'video', 'audio', 'embed', 'object'];

  document
    .querySelectorAll<HTMLElement>(
      embeds.map(tag => `.bo-article-text ${tag}`).join(', '),
    )
    .forEach(embed => {
      const parent = embed.parentElement;

      // Add the class for the parent tag only once
      if (parent && !parent.classList.contains('embed-block')) {
        parent.classList.add('embed-block');
      }
    });
};
